// extracted by mini-css-extract-plugin
module.exports = {"bar":"admin-bar_bar__WJ2TZ"};